/*
  FishTown Main Product
  ---------------------------------------------------------------
  IMPORTANT: this file is a plain asset (.js). Shopify does NOT run
  Liquid inside asset .js files, so this script must never rely on
  Liquid output tags or logic tags. All product data comes from the
  <script type="application/json" data-ft-product-json> block that
  sections/fishtown-main-product.liquid prints.
*/
(function () {
  "use strict";

  function initFishTownProduct(section) {
    if (!section || section.dataset.ftInitialized === "true") return;

    var jsonEl = section.querySelector("[data-ft-product-json]");
    if (!jsonEl) return;

    var data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (error) {
      console.error("FishTown: could not read product JSON.", error);
      return;
    }

    section.dataset.ftInitialized = "true";

    var variants = data.variants || [];

    /* =====================================================
       ELEMENTS
       ===================================================== */

    var form = section.querySelector(".ft-product__form");
    var variantInput = section.querySelector("[data-ft-variant-id]");
    var priceElement = section.querySelector("[data-ft-price]");
    var comparePriceElement = section.querySelector("[data-ft-compare-price]");
    var addButton = section.querySelector("[data-ft-add]");
    var addButtonText = section.querySelector("[data-ft-add-text]");
    var variantMessage = section.querySelector("[data-ft-variant-message]");
    var cartMessage = section.querySelector("[data-ft-cart-message]");
    var quantityInput = section.querySelector("[data-ft-quantity]");
    var optionGroups = Array.prototype.slice.call(
      section.querySelectorAll("[data-option-index]")
    );

    /* =====================================================
       GALLERY SLIDER
       ===================================================== */

    var gallery = section.querySelector("[data-ft-gallery]");
    var track = section.querySelector("[data-ft-media-track]");
    var thumbsWrapper = section.querySelector("[data-ft-thumbs-wrapper]");
    var thumbsStrip = section.querySelector("[data-ft-thumbs]");
    var counter = section.querySelector("[data-ft-counter]");
    var prevButton = section.querySelector("[data-ft-prev]");
    var nextButton = section.querySelector("[data-ft-next]");
    var thumbsPrev = section.querySelector("[data-ft-thumbs-prev]");
    var thumbsNext = section.querySelector("[data-ft-thumbs-next]");

    var slides = [];
    var thumbs = [];
    var activeIndex = 0;

    /* Move any images in the product description into the gallery,
       so they become slides + thumbnails instead of sitting in the text. */
    function pullDescriptionImages() {
      var description = section.querySelector("[data-ft-description]");
      if (!description || !track || !thumbsStrip) return;

      var images = description.querySelectorAll("img");

      Array.prototype.forEach.call(images, function (img, i) {
        var src = img.currentSrc || img.getAttribute("src");
        if (!src) return;

        var id = "desc-" + i;
        var alt = img.getAttribute("alt") || "";

        var slide = document.createElement("div");
        slide.className = "ft-product__media-slide";
        slide.dataset.mediaId = id;
        slide.dataset.mediaAlt = alt;
        slide.dataset.zoomSrc = src;

        var button = document.createElement("button");
        button.type = "button";
        button.className = "ft-product__image-button";
        button.setAttribute("data-ft-zoom", "");
        button.setAttribute("aria-label", "Zoom product image");

        var mainImg = document.createElement("img");
        mainImg.className = "ft-product__main-image";
        mainImg.src = src;
        mainImg.alt = alt;
        mainImg.loading = "lazy";

        button.appendChild(mainImg);
        slide.appendChild(button);
        track.appendChild(slide);

        var thumb = document.createElement("button");
        thumb.type = "button";
        thumb.className = "ft-product__thumb";
        thumb.dataset.ftThumb = id;
        thumb.setAttribute("aria-label", "View product image");

        var thumbImg = document.createElement("img");
        thumbImg.src = src;
        thumbImg.alt = alt;
        thumbImg.loading = "lazy";

        thumb.appendChild(thumbImg);
        thumbsStrip.appendChild(thumb);

        /* Remove the image (and its now-empty wrapper) from the text */
        var parent = img.parentElement;
        img.remove();
        while (
          parent &&
          parent !== description &&
          parent.textContent.trim() === "" &&
          !parent.querySelector("img, video, iframe")
        ) {
          var next = parent.parentElement;
          parent.remove();
          parent = next;
        }
      });
    }

    pullDescriptionImages();

    if (track) {
      slides = Array.prototype.slice.call(
        track.querySelectorAll(".ft-product__media-slide")
      );
    }
    if (thumbsStrip) {
      thumbs = Array.prototype.slice.call(
        thumbsStrip.querySelectorAll("[data-ft-thumb]")
      );
    }

    if (thumbsWrapper) {
      thumbsWrapper.hidden = slides.length < 2;
    }
    if (gallery) {
      gallery.classList.toggle("has-multiple", slides.length > 1);
    }

    function indexOfMedia(mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].dataset.mediaId) === String(mediaId)) return i;
      }
      return -1;
    }

    function pauseVideos(exceptSlide) {
      slides.forEach(function (slide) {
        if (slide === exceptSlide) return;
        slide.querySelectorAll("video").forEach(function (video) {
          video.pause();
        });
      });
    }

    function setActive(index) {
      if (!slides.length) return;
      index = Math.max(0, Math.min(slides.length - 1, index));
      activeIndex = index;

      slides.forEach(function (slide, i) {
        slide.classList.toggle("is-active", i === index);
      });

      var activeId = slides[index].dataset.mediaId;
      var activeThumb = null;

      thumbs.forEach(function (thumb) {
        var isActive = String(thumb.dataset.ftThumb) === String(activeId);
        thumb.classList.toggle("is-active", isActive);
        thumb.setAttribute("aria-current", isActive ? "true" : "false");
        if (isActive) activeThumb = thumb;
      });

      /* Keep the active thumbnail visible inside the thumbnail slider */
      if (activeThumb && thumbsStrip) {
        var left = activeThumb.offsetLeft;
        var right = left + activeThumb.offsetWidth;
        var viewLeft = thumbsStrip.scrollLeft;
        var viewRight = viewLeft + thumbsStrip.clientWidth;

        if (left < viewLeft || right > viewRight) {
          thumbsStrip.scrollTo({
            left: left - (thumbsStrip.clientWidth - activeThumb.offsetWidth) / 2,
            behavior: "smooth"
          });
        }
      }

      if (counter) counter.textContent = index + 1 + " / " + slides.length;
      if (prevButton) prevButton.disabled = index === 0;
      if (nextButton) nextButton.disabled = index === slides.length - 1;

      pauseVideos(slides[index]);
      updateThumbArrows();
    }

    /* Scroll the main slider to a slide and mark it active */
    function goToSlide(index, instant) {
      if (!track || !slides.length) return;
      index = Math.max(0, Math.min(slides.length - 1, index));

      programmaticScroll = true;
      clearTimeout(programmaticTimer);
      programmaticTimer = setTimeout(function () {
        programmaticScroll = false;
      }, instant ? 50 : 700);

      track.scrollTo({
        left: slides[index].offsetLeft,
        behavior: instant ? "instant" : "smooth"
      });

      setActive(index);
    }

    function goToMedia(mediaId, instant) {
      var index = indexOfMedia(mediaId);
      if (index > -1) goToSlide(index, instant);
      return index > -1;
    }

    /* Swipe / trackpad scrolling on the main slider updates the active slide */
    var programmaticScroll = false;
    var programmaticTimer = null;
    var scrollTimer = null;

    if (track) {
      track.addEventListener(
        "scroll",
        function () {
          if (programmaticScroll) return;
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () {
            var width = track.clientWidth || 1;
            var index = Math.round(track.scrollLeft / width);
            if (index !== activeIndex) setActive(index);
          }, 80);
        },
        { passive: true }
      );

      track.addEventListener("keydown", function (event) {
        if (event.key === "ArrowLeft") {
          event.preventDefault();
          goToSlide(activeIndex - 1);
        } else if (event.key === "ArrowRight") {
          event.preventDefault();
          goToSlide(activeIndex + 1);
        }
      });

      /* Keep the current slide in place when the window is resized */
      window.addEventListener("resize", function () {
        clearTimeout(track._ftResize);
        track._ftResize = setTimeout(function () {
          goToSlide(activeIndex, true);
        }, 120);
      });
    }

    if (prevButton) {
      prevButton.addEventListener("click", function () {
        goToSlide(activeIndex - 1);
      });
    }
    if (nextButton) {
      nextButton.addEventListener("click", function () {
        goToSlide(activeIndex + 1);
      });
    }

    /* Click a thumbnail → it becomes the main image */
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        goToMedia(thumb.dataset.ftThumb);
      });
    });

    /* Thumbnail strip arrows */
    function updateThumbArrows() {
      if (!thumbsStrip) return;
      var maxScroll = thumbsStrip.scrollWidth - thumbsStrip.clientWidth;
      var scrollable = maxScroll > 2;
      if (thumbsWrapper) thumbsWrapper.classList.toggle("is-scrollable", scrollable);
      if (thumbsPrev) thumbsPrev.disabled = !scrollable || thumbsStrip.scrollLeft <= 2;
      if (thumbsNext) thumbsNext.disabled = !scrollable || thumbsStrip.scrollLeft >= maxScroll - 2;
    }

    function scrollThumbs(direction) {
      if (!thumbsStrip) return;
      thumbsStrip.scrollBy({
        left: direction * thumbsStrip.clientWidth * 0.8,
        behavior: "smooth"
      });
    }

    if (thumbsPrev) {
      thumbsPrev.addEventListener("click", function () {
        scrollThumbs(-1);
      });
    }
    if (thumbsNext) {
      thumbsNext.addEventListener("click", function () {
        scrollThumbs(1);
      });
    }
    if (thumbsStrip) {
      thumbsStrip.addEventListener("scroll", updateThumbArrows, { passive: true });
      window.addEventListener("resize", updateThumbArrows);
    }

    /* =====================================================
       VARIANT OPTIONS
       ===================================================== */

    var selectedOptions = [];

    optionGroups.forEach(function (group) {
      var index = parseInt(group.dataset.optionIndex, 10);
      var selected = group.querySelector(".is-selected");
      if (selected) selectedOptions[index] = selected.dataset.optionValue;
    });

    function variantMatches(variant, options) {
      if (!variant.options) return false;
      for (var i = 0; i < variant.options.length; i++) {
        if (options[i] !== undefined && variant.options[i] !== options[i]) return false;
      }
      return true;
    }

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        if (!variant.options) continue;
        var all = true;
        for (var j = 0; j < variant.options.length; j++) {
          if (selectedOptions[j] !== variant.options[j]) {
            all = false;
            break;
          }
        }
        if (all) return variant;
      }
      return null;
    }

    function findVariantById(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    /* Reflect selectedOptions on the buttons + labels */
    function syncOptionButtons() {
      optionGroups.forEach(function (group) {
        var index = parseInt(group.dataset.optionIndex, 10);
        var label = group.querySelector("[data-ft-selected-option]");

        group.querySelectorAll("[data-option-value]").forEach(function (button) {
          var value = button.dataset.optionValue;
          var isSelected = value === selectedOptions[index];
          button.classList.toggle("is-selected", isSelected);
          button.setAttribute("aria-pressed", isSelected ? "true" : "false");

          /* Grey out values that are sold out / don't exist with the other selections */
          var test = selectedOptions.slice();
          test[index] = value;
          var available = variants.some(function (variant) {
            return variant.available && variantMatches(variant, test);
          });
          button.classList.toggle("is-unavailable", !available);
        });

        if (label && selectedOptions[index] !== undefined) {
          label.textContent = selectedOptions[index];
        }
      });
    }

    /* =====================================================
       COLOUR → IMAGE MATCHING
       Finds the photo for the selected colour even when the variant has
       no variant image, using (best first):
         1. the image alt text, e.g. "Big Race Tee - Baby Pink - Front"
         2. the image file name, e.g. "Big_Race_-_Baby_Pink_-_Front.jpg"
       Front views win over back views. "Black" never grabs a
       "Black Heather" photo when Black Heather is also a colour.
       ===================================================== */

    function slugify(text) {
      return String(text || "")
        .toLowerCase()
        .replace(/%20|_|\+/g, " ")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }

    function escapeRegExp(text) {
      return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    /* Shopify serves files as .../files/Big_Race_-_Baby_Pink_-_Front.jpg?v=123&width=1400 */
    function fileSlugOf(slide) {
      if (slide._ftFileSlug !== undefined) return slide._ftFileSlug;
      var img = slide.querySelector("img");
      var src = img ? img.getAttribute("src") || "" : slide.dataset.zoomSrc || "";
      try {
        src = decodeURIComponent(src);
      } catch (error) {
        /* keep as is */
      }
      src = src.split("?")[0];
      var name = src.substring(src.lastIndexOf("/") + 1)
        .replace(/\.[a-z0-9]+$/i, "")                    /* extension */
        .replace(/_\d+x\d*$/i, "")                       /* _1400x size suffix */
        .replace(/_[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i, ""); /* duplicate-upload id */
      slide._ftFileSlug = slugify(name);
      return slide._ftFileSlug;
    }

    var VIEW_WORDS = "front|back|side|detail|details|main|close|closeup|close-up|zoom|flat|lifestyle|model";

    /* How well does this slide show this colour? 0 = not at all */
    function colourScore(slide, value) {
      var colour = slugify(value);
      if (!colour) return 0;

      var score = 0;
      var alt = slide.dataset.mediaAlt || "";
      var altParts = alt.toLowerCase().split(/\s+[-–—|\/:,]\s+|\s*[()]\s*/).map(function (part) {
        return part.trim();
      });
      var altSlug = slugify(alt);
      var file = fileSlugOf(slide);
      var c = escapeRegExp(colour);

      if (altParts.indexOf(String(value).toLowerCase().trim()) > -1) {
        score = 100;                                   /* "… - Baby Pink - Front" */
      } else if (new RegExp("(^|-)" + c + "(-|$)").test(altSlug)) {
        score = 70;                                    /* colour somewhere in the alt text */
      }

      if (score < 100 && file) {
        if (new RegExp("(^|-)" + c + "(-(" + VIEW_WORDS + "|\\d+)(-|$)|$)").test(file)) {
          score = Math.max(score, 90);                 /* "...-baby-pink-front" */
        } else if (new RegExp("(^|-)" + c + "(-|$)").test(file)) {
          score = Math.max(score, 60);                 /* colour somewhere in the file name */
        }
      }

      if (!score) return 0;

      var view = altSlug + " " + file;
      if (/(^|-)front(-|$|\s)/.test(view)) score += 3;
      if (/(^|-)back(-|$|\s)/.test(view)) score -= 3;
      return score;
    }

    /* Which option is the colour? (Colour / Color / Shade…) */
    function colourOptionIndexes() {
      var found = [];
      optionGroups.forEach(function (group) {
        var name = group.dataset.optionName || "";
        if (/colou?r|shade|tint/.test(name)) found.push(parseInt(group.dataset.optionIndex, 10));
      });
      if (found.length) return found;
      /* No option called "colour": try every option */
      return optionGroups.map(function (group) {
        return parseInt(group.dataset.optionIndex, 10);
      });
    }

    function optionValuesAt(index) {
      var group = section.querySelector('[data-option-index="' + index + '"]');
      if (!group) return [];
      return Array.prototype.map.call(group.querySelectorAll("[data-option-value]"), function (button) {
        return button.dataset.optionValue;
      });
    }

    function bestSlideForValue(index, value) {
      var others = optionValuesAt(index).filter(function (other) {
        var o = slugify(other);
        var v = slugify(value);
        /* longer colours that contain this one, e.g. "Black Heather" for "Black" */
        return o !== v && new RegExp("(^|-)" + escapeRegExp(v) + "(-|$)").test(o);
      });

      var best = null;
      var bestScore = 0;

      slides.forEach(function (slide) {
        var score = colourScore(slide, value);
        if (!score) return;

        /* Photo actually belongs to a longer colour name → skip it */
        for (var i = 0; i < others.length; i++) {
          if (colourScore(slide, others[i]) >= score) return;
        }

        if (score > bestScore) {
          bestScore = score;
          best = slide;
        }
      });

      return best;
    }

    /* The media id of the best photo for the selected colour, or null */
    function findMediaForOptions() {
      var indexes = colourOptionIndexes();
      for (var i = 0; i < indexes.length; i++) {
        var value = selectedOptions[indexes[i]];
        if (!value) continue;
        var slide = bestSlideForValue(indexes[i], value);
        if (slide) return slide.dataset.mediaId;
      }
      return null;
    }

    /* Does the slide on screen already show the selected colour? */
    function activeSlideShowsColour() {
      var slide = slides[activeIndex];
      if (!slide) return false;
      var indexes = colourOptionIndexes();
      for (var i = 0; i < indexes.length; i++) {
        var value = selectedOptions[indexes[i]];
        if (value && colourScore(slide, value) > 0) return true;
      }
      return false;
    }

    function colourKey() {
      return colourOptionIndexes()
        .map(function (index) {
          return selectedOptions[index] || "";
        })
        .join("|");
    }

    var lastColourKey = null;

    /* =====================================================
       MONEY
       ===================================================== */

    function formatWithDelimiters(cents, precision, thousands, decimal) {
      thousands = thousands === undefined ? "," : thousands;
      decimal = decimal === undefined ? "." : decimal;
      var number = (cents / 100).toFixed(precision);
      var parts = number.split(".");
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    function formatMoney(cents) {
      var format = data.moneyFormat || "£{{amount}}";
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
        switch (key) {
          case "amount_no_decimals":
            return formatWithDelimiters(cents, 0);
          case "amount_with_comma_separator":
            return formatWithDelimiters(cents, 2, ".", ",");
          case "amount_no_decimals_with_comma_separator":
            return formatWithDelimiters(cents, 0, ".", ",");
          case "amount_with_apostrophe_separator":
            return formatWithDelimiters(cents, 2, "'", ".");
          default:
            return formatWithDelimiters(cents, 2);
        }
      });
    }

    /* =====================================================
       UPDATE VARIANT
       ===================================================== */

    function updateVariant(options) {
      options = options || {};
      var variant = findVariant();

      syncOptionButtons();
      if (variantMessage) variantMessage.textContent = "";

      if (!variant) {
        if (variantInput) variantInput.value = "";
        if (addButton) addButton.disabled = true;
        if (addButtonText) addButtonText.textContent = data.unavailableText || "UNAVAILABLE";
        if (variantMessage) variantMessage.textContent = "This combination is unavailable.";
        return;
      }

      if (variantInput) variantInput.value = variant.id;

      if (priceElement) priceElement.textContent = formatMoney(variant.price);

      if (comparePriceElement) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceElement.textContent = formatMoney(variant.compare_at_price);
          comparePriceElement.style.display = "";
        } else {
          comparePriceElement.style.display = "none";
        }
      }

      if (addButton && addButtonText && !isAdding) {
        clearTimeout(addButton._ftStateTimer);
        addButton.classList.remove("is-added");
        if (variant.available) {
          addButton.disabled = false;
          addButtonText.textContent = data.addText || "ADD TO BAG";
        } else {
          addButton.disabled = true;
          addButtonText.textContent = data.soldOutText || "SOLD OUT";
        }
      }

      if (options.updateUrl !== false) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", variant.id);
          window.history.replaceState({}, "", url.toString());
        } catch (error) {
          /* ignore */
        }
      }

      /* Switch the main image to the selected colour.
         Only when the colour changes — picking a size keeps the photo the
         shopper is looking at (e.g. the back view of the same colour). */
      if (options.updateMedia !== false) {
        var key = colourKey();
        var colourChanged = key !== lastColourKey;
        lastColourKey = key;

        if (colourChanged || (variant.media_id && !activeSlideShowsColour())) {
          var moved = false;

          /* 1. The variant image set in Shopify admin */
          if (variant.media_id) moved = goToMedia(variant.media_id, options.instant);

          /* 2. A photo whose alt text / file name names the colour */
          if (!moved) {
            var match = findMediaForOptions();
            if (match) moved = goToMedia(match, options.instant);
          }

          if (!moved && colourChanged && window.console) {
            console.info(
              "FishTown: no photo found for \"" + key.replace(/\|/g, " / ") + "\". " +
              "Set a variant image in Shopify, or put the colour name in the image's alt text or file name."
            );
          }
        }
      }

      section.dispatchEvent(
        new CustomEvent("fishtown:variant-change", {
          bubbles: true,
          detail: { variant: variant }
        })
      );
    }

    /* =====================================================
       OPTION CLICK
       ===================================================== */

    optionGroups.forEach(function (group) {
      var index = parseInt(group.dataset.optionIndex, 10);

      group.querySelectorAll("[data-option-value]").forEach(function (button) {
        button.addEventListener("click", function () {
          selectedOptions[index] = button.dataset.optionValue;

          /* If this combination doesn't exist (e.g. a size not made in this
             colour), keep the clicked value and pick the closest valid
             variant for the other options instead of showing "unavailable". */
          if (!findVariant()) {
            var fallback = null;
            for (var i = 0; i < variants.length; i++) {
              var v = variants[i];
              if (v.options && v.options[index] === selectedOptions[index]) {
                if (v.available) {
                  fallback = v;
                  break;
                }
                if (!fallback) fallback = v;
              }
            }
            if (fallback) selectedOptions = fallback.options.slice();
          }

          updateVariant();
        });
      });
    });

    /* =====================================================
       QUANTITY
       ===================================================== */

    var minus = section.querySelector("[data-ft-quantity-minus]");
    var plus = section.querySelector("[data-ft-quantity-plus]");

    if (minus && quantityInput) {
      minus.addEventListener("click", function () {
        var current = parseInt(quantityInput.value, 10) || 1;
        quantityInput.value = Math.max(1, current - 1);
      });
    }

    if (plus && quantityInput) {
      plus.addEventListener("click", function () {
        var current = parseInt(quantityInput.value, 10) || 1;
        quantityInput.value = Math.min(99, current + 1);
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener("change", function () {
        var value = parseInt(this.value, 10) || 1;
        this.value = Math.max(1, Math.min(99, value));
      });
    }

    /* =====================================================
       ADD TO CART
       ===================================================== */

    var rootUrl =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var cartAddUrl = (data.cartAddUrl || rootUrl + "cart/add") + ".js";
    var cartJsUrl = (data.cartUrl || rootUrl + "cart") + ".js";

    var isAdding = false;
    var MIN_LOADING_MS = 700; /* keep "Adding…" on screen long enough to be seen */

    function wait(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }

    function setAddState(state) {
      if (!addButton || !addButtonText) return;
      clearTimeout(addButton._ftStateTimer);
      addButton.classList.remove("is-loading", "is-added");

      if (state === "loading") {
        addButton.classList.add("is-loading");
        addButton.disabled = true;
        addButton.setAttribute("aria-busy", "true");
        addButtonText.textContent = data.addingText || "ADDING…";
        return;
      }

      addButton.removeAttribute("aria-busy");

      if (state === "added") {
        addButton.classList.add("is-added");
        addButton.disabled = true;
        addButtonText.textContent = data.addedText || "ADDED ✓";
        addButton._ftStateTimer = setTimeout(function () {
          setAddState("idle");
        }, 1800);
        return;
      }

      /* idle: back to the normal state for the selected variant */
      var variant = findVariant();
      if (variant && variant.available) {
        addButton.disabled = false;
        addButtonText.textContent = data.addText || "ADD TO BAG";
      } else {
        addButton.disabled = true;
        addButtonText.textContent = variant
          ? data.soldOutText || "SOLD OUT"
          : data.unavailableText || "UNAVAILABLE";
      }
    }

    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();

        if (isAdding) return;

        if (!variantInput || !variantInput.value) {
          showCartMessage("Please select an available option.", "error");
          return;
        }

        if (addButton && addButton.disabled) return;

        isAdding = true;
        var formData = new FormData(form);
        setAddState("loading");
        showCartMessage("Adding to your bag…", "loading");

        var request = fetch(cartAddUrl, {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData
        }).then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) {
              throw new Error(body.description || body.message || "Unable to add product.");
            }
            return body;
          });
        });

        Promise.all([request, wait(MIN_LOADING_MS)])
          .then(function (results) {
            var item = results[0];
            setAddState("added");
            showCartMessage("Added to your bag.", "success");
            updateCartCount();

            document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart: item } }));
            document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: item } }));
          })
          .catch(function (error) {
            setAddState("idle");
            showCartMessage(error.message || "Something went wrong. Please try again.", "error");
          })
          .then(function () {
            isAdding = false;
          });
      });
    }

    function updateCartCount() {
      return fetch(cartJsUrl, { headers: { Accept: "application/json" } })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          if (!cart) return;
          document
            .querySelectorAll("[data-cart-count], .cart-count, .cart-count-bubble span")
            .forEach(function (element) {
              element.textContent = cart.item_count;
            });
        })
        .catch(function (error) {
          console.warn("FishTown cart count update failed.", error);
        });
    }

    /* type: "loading" | "success" | "error" */
    function showCartMessage(message, type) {
      if (!cartMessage) return;
      clearTimeout(cartMessage._ftTimeout);

      cartMessage.classList.remove("is-error", "is-loading", "is-success");
      cartMessage.textContent = "";
      if (type) cartMessage.classList.add("is-" + type);

      var text = document.createElement("span");
      text.textContent = message;
      cartMessage.appendChild(text);

      if (type === "success") {
        var link = document.createElement("a");
        link.href = data.cartUrl || rootUrl + "cart";
        link.className = "ft-product__cart-link";
        link.textContent = "View bag";
        cartMessage.appendChild(link);
      }

      /* The loading message stays until the request finishes */
      if (type !== "loading") {
        cartMessage._ftTimeout = setTimeout(function () {
          cartMessage.textContent = "";
          cartMessage.classList.remove("is-error", "is-success");
        }, type === "success" ? 6000 : 5000);
      }
    }

    /* =====================================================
       LIGHTBOX (zoom) — with previous / next
       ===================================================== */

    var lightbox = section.querySelector("[data-ft-lightbox]");
    var lightboxImage = section.querySelector("[data-ft-lightbox-image]");
    var lightboxClose = section.querySelector("[data-ft-lightbox-close]");
    var lightboxPrev = section.querySelector("[data-ft-lightbox-prev]");
    var lightboxNext = section.querySelector("[data-ft-lightbox-next]");
    var lightboxCounter = section.querySelector("[data-ft-lightbox-counter]");

    /* Only image slides can be shown in the lightbox */
    function imageSlideIndexes() {
      var list = [];
      slides.forEach(function (slide, i) {
        if (slide.querySelector("img.ft-product__main-image, .ft-product__image-button img")) {
          list.push(i);
        }
      });
      return list;
    }

    function showInLightbox(index) {
      var slide = slides[index];
      if (!slide || !lightboxImage) return false;
      var img = slide.querySelector("img");
      if (!img) return false;

      lightboxImage.src = slide.dataset.zoomSrc || img.currentSrc || img.src;
      lightboxImage.alt = img.alt || "";

      var list = imageSlideIndexes();
      var position = list.indexOf(index);
      if (lightboxCounter) lightboxCounter.textContent = position + 1 + " / " + list.length;
      if (lightboxPrev) lightboxPrev.hidden = list.length < 2;
      if (lightboxNext) lightboxNext.hidden = list.length < 2;
      return true;
    }

    function openLightbox() {
      if (!lightbox) return;
      if (!showInLightbox(activeIndex)) return;
      lightbox.classList.add("is-open");
      lightbox.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      if (lightboxClose) lightboxClose.focus();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove("is-open");
      lightbox.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }

    function stepLightbox(direction) {
      var list = imageSlideIndexes();
      if (list.length < 2) return;
      var position = list.indexOf(activeIndex);
      if (position < 0) position = 0;
      var nextIndex = list[(position + direction + list.length) % list.length];
      goToSlide(nextIndex, true); /* keep the page gallery in sync */
      showInLightbox(nextIndex);
    }

    /* Includes the description images, which were moved in above */
    section.querySelectorAll("[data-ft-zoom]").forEach(function (button) {
      button.addEventListener("click", openLightbox);
    });

    if (lightboxClose) lightboxClose.addEventListener("click", closeLightbox);
    if (lightboxPrev) lightboxPrev.addEventListener("click", function () { stepLightbox(-1); });
    if (lightboxNext) lightboxNext.addEventListener("click", function () { stepLightbox(1); });

    if (lightbox) {
      lightbox.addEventListener("click", function (event) {
        if (event.target === lightbox || event.target.classList.contains("ft-product__lightbox-inner")) {
          closeLightbox();
        }
      });
    }

    document.addEventListener("keydown", function (event) {
      if (!lightbox || !lightbox.classList.contains("is-open")) return;
      if (event.key === "Escape") closeLightbox();
      if (event.key === "ArrowLeft") stepLightbox(-1);
      if (event.key === "ArrowRight") stepLightbox(1);
    });

    /* =====================================================
       WISHLIST
       ===================================================== */

    var wishlist = section.querySelector("[data-ft-wishlist]");
    if (wishlist) {
      wishlist.addEventListener("click", function () {
        var active = wishlist.classList.toggle("is-active");
        wishlist.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }

    /* =====================================================
       INITIAL STATE
       ===================================================== */

    var initialVariant = findVariantById(variantInput && variantInput.value) ||
      findVariantById(data.initialVariantId);
    if (initialVariant && initialVariant.options) {
      selectedOptions = initialVariant.options.slice();
    }

    setActive(0);
    updateVariant({ updateUrl: false, instant: true });
    updateThumbArrows();
  }

  /* =======================================================
     BOOT + SHOPIFY THEME EDITOR
     ======================================================= */

  function initAll() {
    document.querySelectorAll(".ft-product").forEach(initFishTownProduct);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector(".ft-product");
    if (section) initFishTownProduct(section);
  });
})();
